export const setFunnelStep = async (step = 'undefined') => {
  __init()
  window.dataLayer.push({
    event: 'funnel',
    funnelStep: step.toString(),
  })
}

export const setFunnelStepWithEcommerce = async (
  id,
  total,
  step = 'undefined',
) => {
  __init()
  window.dataLayer.push({
    event: 'funnel',
    funnelStep: step.toString(),
    ecommerce: {
      currencyCode: 'EUR',
      purchase: {
        actionField: {
          id: id,
          revenue: total.toFixed(2),
        },
      },
    },
  })
}

export const trackGoogleAds = async (step = 'undefined', company = false) => {
  __init()
  window.dataLayer.push({
    event: 'funnel',
    funnelStep: step.toString(),
    user: {
      is_company: company ? 1 : 0,
    },
  })
}

export const trackSentForm = async () => {
  __init()
  window.dataLayer.push({
    event: 'formSent',
  })
}

export const trackPageView = async (
  path = '*unkonwn*',
  title = '*unknown*',
) => {
  __init()
  window.dataLayer.push({
    event: 'Pageview',
    pagePath: path,
    pageTitle: title, //some arbitrary name for the page/state
  })
}

export const trackUser = async (id, email, hash, ip, type = 'old') => {
  __init()
  const event = type === 'new' ? 'signup' : 'login'

  window.dataLayer.push({
    event: event,
    user: {
      id: id,
      email: email,
      hash: hash,
      ip: ip,
    },
  })
}

export const trackPurchase = async (pid, amount, vatRate, type) => {
  __init()

  let tax = +(amount * vatRate).toFixed(2)
  window.dataLayer.push({
    ecommerce: {
      currencyCode: 'EUR',
      purchase: {
        actionField: {
          id: pid,
          affiliation: 'Online',
          revenue: amount.toFixed(2),
          tax: tax,
        },
        products: [
          {
            name: type,

            id: '123',
            price: amount.toFixed(2),
            category: 'online order',
            variant: 'online order',
            brand: 'Translated',
            quantity: 1,
          },
        ],
      },
    },
  })
}

const __init = () => {
  window.dataLayer = window.dataLayer || []
  if (['test', 'development'].indexOf(process.env.NODE_ENV) >= 0) {
    window.dataLayer.push({is_dev_environment: 1})
  } else {
    window.dataLayer.push({is_dev_environment: 0})
  }
}

/*
 window.document.addEventListener('confirm', ({ detail: order }) => {
        window.universal_variable.transaction = {
            order_id: order.id_project,
            subtotal: order.amount,
            subtotal_include_tax: false,
            total: order.amount,
            currency: 'EUR',
            shipping_cost: 0,
            tax: +(order.amount * order.vat_rate).toFixed(2),
            line_items: [{
                product: {
                    name: order.type,
                    sku_code: 123,
                    category: 'online order',
                    unit_sale_price: order.amount
                },
                quantity: 1
            }]
        };
    });
*/
